function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { View } from 'react-native';
import PropTypes from 'prop-types';
import xmldom from 'xmldom';
import resolveAssetSource from './resolveAssetSource';
import memoize from 'lodash/memoize';
import request from 'superagent';
import { makeCancellable } from '@dkrm/general-libs/Utils/promise';
import Svg, { Circle, Ellipse, G, LinearGradient, RadialGradient, Line, Path, Polygon, Polyline, Rect, Text, TSpan, Defs, Stop } from 'react-native-svg';
import * as utils from './utils';
const ACCEPTED_SVG_ELEMENTS = ['svg', 'g', 'circle', 'path', 'rect', 'defs', 'line', 'linearGradient', 'radialGradient', 'stop', 'ellipse', 'polygon', 'polyline', 'text', 'tspan'];

// Attributes from SVG elements that are mapped directly.
const SVG_ATTS = ['viewBox', 'width', 'height'];
const G_ATTS = ['id'];
const CIRCLE_ATTS = ['cx', 'cy', 'r'];
const PATH_ATTS = ['d'];
const RECT_ATTS = ['width', 'height'];
const LINE_ATTS = ['x1', 'y1', 'x2', 'y2'];
const LINEARG_ATTS = LINE_ATTS.concat(['id', 'gradientUnits']);
const RADIALG_ATTS = CIRCLE_ATTS.concat(['id', 'gradientUnits']);
const STOP_ATTS = ['offset'];
const ELLIPSE_ATTS = ['cx', 'cy', 'rx', 'ry'];
const TEXT_ATTS = ['fontFamily', 'fontSize', 'fontWeight'];
const POLYGON_ATTS = ['points'];
const POLYLINE_ATTS = ['points'];
const COMMON_ATTS = ['fill', 'fillOpacity', 'stroke', 'strokeWidth', 'strokeOpacity', 'opacity', 'strokeLinecap', 'strokeLinejoin', 'strokeDasharray', 'strokeDashoffset', 'x', 'y', 'rotate', 'scale', 'origin', 'originX', 'originY', 'transform'];
let ind = 0;
function fixYPosition(y, node) {
  if (node.attributes) {
    const fontSizeAttr = Object.keys(node.attributes).find(a => node.attributes[a].name === 'font-size');
    if (fontSizeAttr) {
      return `${parseFloat(y) - parseFloat(node.attributes[fontSizeAttr].value)}`;
    }
  }
  if (!node.parentNode) {
    return y;
  }
  return fixYPosition(y, node.parentNode);
}
function fetchBody(uri) {
  return new Promise((resolve, reject) => request.get(uri, (err, res) => {
    if (err) {
      reject(err);
    } else {
      resolve(res.text);
    }
  }));
}
const fetchBodyCached = memoize(fetchBody);
class SvgUri extends React.PureComponent {
  constructor(props) {
    super(props);
    this.createSVGElement = this.createSVGElement.bind(this);
    this.obtainComponentAtts = this.obtainComponentAtts.bind(this);
    this.inspectNode = this.inspectNode.bind(this);
    this.state = {
      fill: props.fill,
      svgXmlData: props.svgXmlData
    };
  }
  componentDidMount() {
    if (this.props.source) {
      const source = resolveAssetSource(this.props.source) || {};
      this.fetchSVGData(source.uri);
    }
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    let isSourceSet = false;
    if (nextProps.source) {
      const source = resolveAssetSource(nextProps.source) || {};
      const oldSource = resolveAssetSource(this.props.source) || {};
      if (source.uri !== oldSource.uri) {
        this.fetchSVGData(source.uri);
        isSourceSet = true;
      }
    }
    if (!isSourceSet && nextProps.svgXmlData !== this.props.svgXmlData) {
      this.setState({
        svgXmlData: nextProps.svgXmlData
      });
    }
    if (nextProps.fill !== this.props.fill) {
      this.setState({
        fill: nextProps.fill
      });
    }
  }
  componentWillUnmount() {
    if (this.fetchBodyCached) {
      this.fetchBodyCached.cancel();
    }
  }
  async fetchSVGData(uri) {
    this.fetchBodyCached = makeCancellable(fetchBodyCached(uri));
    try {
      const body = await this.fetchBodyCached;
      this.setState({
        svgXmlData: body
      });
    } catch (err) {
      if (!err.isCancelled) console.error(err);
    }
  }
  createSVGElement(node, childs) {
    let componentAtts = {};
    const i = ind++;
    switch (node.nodeName) {
      case 'svg':
        componentAtts = this.obtainComponentAtts(node, SVG_ATTS);
        if (this.props.width) {
          componentAtts.width = this.props.width;
        }
        if (this.props.height) {
          componentAtts.height = this.props.height;
        }
        return /*#__PURE__*/React.createElement(Svg, _extends({
          key: i
        }, componentAtts), childs);
      case 'g':
        componentAtts = this.obtainComponentAtts(node, G_ATTS);
        return /*#__PURE__*/React.createElement(G, _extends({
          key: i
        }, componentAtts), childs);
      case 'path':
        componentAtts = this.obtainComponentAtts(node, PATH_ATTS);
        return /*#__PURE__*/React.createElement(Path, _extends({
          key: i
        }, componentAtts), childs);
      case 'circle':
        componentAtts = this.obtainComponentAtts(node, CIRCLE_ATTS);
        return /*#__PURE__*/React.createElement(Circle, _extends({
          key: i
        }, componentAtts), childs);
      case 'rect':
        componentAtts = this.obtainComponentAtts(node, RECT_ATTS);
        return /*#__PURE__*/React.createElement(Rect, _extends({
          key: i
        }, componentAtts), childs);
      case 'line':
        componentAtts = this.obtainComponentAtts(node, LINE_ATTS);
        return /*#__PURE__*/React.createElement(Line, _extends({
          key: i
        }, componentAtts), childs);
      case 'defs':
        return /*#__PURE__*/React.createElement(Defs, {
          key: i
        }, childs);
      case 'linearGradient':
        componentAtts = this.obtainComponentAtts(node, LINEARG_ATTS);
        return /*#__PURE__*/React.createElement(LinearGradient, _extends({
          key: i
        }, componentAtts), childs);
      case 'radialGradient':
        componentAtts = this.obtainComponentAtts(node, RADIALG_ATTS);
        return /*#__PURE__*/React.createElement(RadialGradient, _extends({
          key: i
        }, componentAtts), childs);
      case 'stop':
        componentAtts = this.obtainComponentAtts(node, STOP_ATTS);
        return /*#__PURE__*/React.createElement(Stop, _extends({
          key: i
        }, componentAtts), childs);
      case 'ellipse':
        componentAtts = this.obtainComponentAtts(node, ELLIPSE_ATTS);
        return /*#__PURE__*/React.createElement(Ellipse, _extends({
          key: i
        }, componentAtts), childs);
      case 'polygon':
        componentAtts = this.obtainComponentAtts(node, POLYGON_ATTS);
        return /*#__PURE__*/React.createElement(Polygon, _extends({
          key: i
        }, componentAtts), childs);
      case 'polyline':
        componentAtts = this.obtainComponentAtts(node, POLYLINE_ATTS);
        return /*#__PURE__*/React.createElement(Polyline, _extends({
          key: i
        }, componentAtts), childs);
      case 'text':
        componentAtts = this.obtainComponentAtts(node, TEXT_ATTS);
        if (componentAtts.y) {
          componentAtts.y = fixYPosition(componentAtts.y, node);
        }
        return /*#__PURE__*/React.createElement(Text, _extends({
          key: i
        }, componentAtts), childs);
      case 'tspan':
        componentAtts = this.obtainComponentAtts(node, TEXT_ATTS);
        if (componentAtts.y) {
          componentAtts.y = fixYPosition(componentAtts.y, node);
        }
        return /*#__PURE__*/React.createElement(TSpan, _extends({
          key: i
        }, componentAtts), childs);
      default:
        return null;
    }
  }
  obtainComponentAtts({
    attributes
  }, enabledAttributes) {
    const styleAtts = {};
    if (this.state.fill && this.props.fillAll) {
      styleAtts.fill = this.state.fill;
    }
    Array.from(attributes).forEach(({
      nodeName,
      nodeValue
    }) => {
      Object.assign(styleAtts, utils.transformStyle({
        nodeName,
        nodeValue,
        fillProp: this.state.fill
      }));
    });
    const componentAtts = Array.from(attributes).map(utils.camelCaseNodeName).map(utils.removePixelsFromNodeValue).filter(utils.getEnabledAttributes(enabledAttributes.concat(COMMON_ATTS))).reduce((acc, {
      nodeName,
      nodeValue
    }) => {
      acc[nodeName] = this.state.fill && nodeName === 'fill' && nodeValue !== 'none' ? this.state.fill : nodeValue;
      return acc;
    }, {});
    Object.assign(componentAtts, styleAtts);
    return componentAtts;
  }
  inspectNode(node) {
    // Only process accepted elements
    if (!ACCEPTED_SVG_ELEMENTS.includes(node.nodeName)) {
      return null;
    }
    const textValue = node.nodeValue;
    if (textValue) {
      return textValue;
    }
    // Process the xml node
    const arrayElements = [];

    // if have children process them.
    // Recursive function.
    if (node.childNodes && node.childNodes.length > 0) {
      for (let i = 0; i < node.childNodes.length; i++) {
        const nodo = this.inspectNode(node.childNodes[i]);
        if (nodo != null) {
          arrayElements.push(nodo);
        }
      }
    }
    return this.createSVGElement(node, arrayElements);
  }
  render() {
    try {
      if (this.state.svgXmlData == null) {
        return null;
      }
      const inputSVG = this.state.svgXmlData.substring(this.state.svgXmlData.indexOf('<svg '), this.state.svgXmlData.indexOf('</svg>') + 6);
      const doc = new xmldom.DOMParser().parseFromString(inputSVG);
      const rootSVG = this.inspectNode(doc.childNodes[0]);
      return /*#__PURE__*/React.createElement(View, {
        style: this.props.style
      }, rootSVG);
    } catch (e) {
      console.error('ERROR SVG', e);
      return null;
    }
  }
}
SvgUri.propTypes = process.env.NODE_ENV !== "production" ? {
  style: PropTypes.shape(),
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  svgXmlData: PropTypes.string,
  source: PropTypes.any,
  fill: PropTypes.string,
  fillAll: PropTypes.bool
} : {};
const svgUri = __CLIENT__ ? SvgUri : () => null;
export default svgUri;